import React from "react";

const defaultTargetDetailsTDT = [
  {
    targetDescriptionTDT: "",
    metricUsedTDT: "",
    scopeCoveredTDT: "",
    timePeriodTDT: "",
    baseYearTDT: "",
    interimMilestonesTDT: "",
    targetTypeTDT: "",
  },
];

const TargetDetailsTable = ({ targetDetailsTDT, setTargetDetailsTDT }) => {
  const handleChange = (i, field, value) => {
    const updated = [...targetDetailsTDT];
    updated[i][field] = value;
    setTargetDetailsTDT(updated);
  };

  const addRow = () =>
    setTargetDetailsTDT([
      ...targetDetailsTDT,
      {
        targetDescriptionTDT: "",
        metricUsedTDT: "",
        scopeCoveredTDT: "",
        timePeriodTDT: "",
        baseYearTDT: "",
        interimMilestonesTDT: "",
        targetTypeTDT: "",
      },
    ]);

  const removeRow = () =>
    targetDetailsTDT.length > 1 &&
    setTargetDetailsTDT(targetDetailsTDT.slice(0, -1));

  // table cell/header/input styles
  const cell = { padding: "15px", textAlign: "left", verticalAlign: "top" };
  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };
  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };
  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      {/* bordered wrapper ONLY around the table */}
      <div
        style={{
          borderRadius: 12,
          overflow: "hidden",
          border: "1px solid #000",
        }}
      >
        <style>{`
          .tdtTable{ width:100%; border-collapse:collapse; }
          .tdtTable th, .tdtTable td{ border:1px solid #000; padding:15px; vertical-align:top; text-align:left; }
          .tdtTable thead th{ background:#d3c9ce; font-weight:700; text-align:center; }
          /* hide outer edges (wrapper draws them) */
          .tdtTable thead tr:first-child th{ border-top:0; }
          .tdtTable tr th:first-child, .tdtTable tr td:first-child{ border-left:0; }
          .tdtTable tr th:last-child, .tdtTable tr td:last-child{ border-right:0; }
          .tdtTable tbody tr:last-child td{ border-bottom:0; }
        `}</style>

        <table className="tdtTable">
          <thead>
            <tr>
              <th style={header}>Target description</th>
              <th style={header}>Metric used</th>
              <th style={header}>Scope covered</th>
              <th style={header}>Time period</th>
              <th style={header}>Base year</th>
              <th style={header}>Interim milestones</th>
              <th style={header}>
                Target type
                <br />
                (Absolute/ Intensity)
              </th>
            </tr>
          </thead>

          <tbody>
            {targetDetailsTDT.map((row, idx) => (
              <tr key={idx}>
                <td style={cell}>
                  <input
                    style={inputStyle}
                    placeholder="Enter data"
                    value={row.targetDescriptionTDT}
                    onChange={(e) =>
                      handleChange(idx, "targetDescriptionTDT", e.target.value)
                    }
                  />
                </td>
                <td style={cell}>
                  <input
                    style={inputStyle}
                    placeholder="Enter data"
                    value={row.metricUsedTDT}
                    onChange={(e) =>
                      handleChange(idx, "metricUsedTDT", e.target.value)
                    }
                  />
                </td>
                <td style={cell}>
                  <input
                    style={inputStyle}
                    placeholder="Enter data"
                    value={row.scopeCoveredTDT}
                    onChange={(e) =>
                      handleChange(idx, "scopeCoveredTDT", e.target.value)
                    }
                  />
                </td>
                <td style={cell}>
                  <input
                    style={inputStyle}
                    placeholder="Enter data"
                    value={row.timePeriodTDT}
                    onChange={(e) =>
                      handleChange(idx, "timePeriodTDT", e.target.value)
                    }
                  />
                </td>
                <td style={cell}>
                  <input
                    style={inputStyle}
                    placeholder="Enter data"
                    value={row.baseYearTDT}
                    onChange={(e) =>
                      handleChange(idx, "baseYearTDT", e.target.value)
                    }
                  />
                </td>
                <td style={cell}>
                  <input
                    style={inputStyle}
                    placeholder="Enter data"
                    value={row.interimMilestonesTDT}
                    onChange={(e) =>
                      handleChange(idx, "interimMilestonesTDT", e.target.value)
                    }
                  />
                </td>
                <td style={cell}>
                  <input
                    style={inputStyle}
                    placeholder="Enter data"
                    value={row.targetTypeTDT}
                    onChange={(e) =>
                      handleChange(idx, "targetTypeTDT", e.target.value)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Buttons OUTSIDE the bordered wrapper */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          gap: 10,
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add Row
        </button>
      </div>
    </div>
  );
};

export default TargetDetailsTable;
